import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import legacyParse from '../../../node_modules/@date-fns/upgrade/v2/legacyParse/index.js';
import isValid from '../../../node_modules/date-fns/esm/isValid/index.js';
import format from '../../../node_modules/date-fns/esm/format/index.js';
import getDaysInMonth from '../../../node_modules/date-fns/esm/getDaysInMonth/index.js';
import isAfter from '../../../node_modules/date-fns/esm/isAfter/index.js';
import isBefore from '../../../node_modules/date-fns/esm/isBefore/index.js';
import isWithinInterval from '../../../node_modules/date-fns/esm/isWithinInterval/index.js';
import _TextInput from '../TextInput/index.js';

var _excluded = ["after", "afterMessage", "afterToday", "before", "beforeMessage", "beforeToday", "between", "customErrorMessage", "field", "label", "lang", "theme", "optional"];
var validate = function validate(value, customError, lang) {
  var validatedDate = value && value.length < 10 && value;
  var parsedDate = legacyParse(value);
  var month = value && value.split('/')[0];
  var day = value && value.split('/')[1];
  var year = value && value.split('/')[2];
  var daysInMonth = getDaysInMonth(new Date(parseInt(year, 10), parseInt(month, 10) - 1));
  var isMonthValid = daysInMonth < parseInt(day, 10);
  var validationString = customError ? customError : lang === 'en' ? 'Invalid Date' : 'Fecha invalida';
  return !isValid(parsedDate) || validatedDate || isMonthValid ? validationString : undefined;
};
var validateAfter = function validateAfter(value, after, customError, afterMessage, lang) {
  var validatedYear = value && value.length < 10;
  var afterDate = legacyParse(after);
  var parsedDate = legacyParse(value);
  var validationString = customError ? customError : lang === 'en' ? 'Invalid Date' : 'Fecha invalida';
  var rangeValidationString = customError ? customError : lang === 'en' ? 'Date is not after' : 'La fecha no es después';
  if (validatedYear) {
    return validationString;
  }
  return validate(value, customError, lang) || !isAfter(parsedDate, afterDate) ? afterMessage || "".concat(rangeValidationString, " ").concat(after) : undefined;
};
var validateBefore = function validateBefore(value, before, customError, beforeMessage, lang) {
  var validatedYear = value && value.length < 10;
  var beforeDate = legacyParse(before);
  var parsedDate = legacyParse(value);
  var validationString = customError ? customError : lang === 'en' ? 'Invalid Date' : 'Fecha invalida';
  var rangeValidationString = customError ? customError : lang === 'en' ? 'Date is not before' : 'La fecha no es antes';
  if (validatedYear) {
    return validationString;
  }
  return validate(value, customError, lang) || !isBefore(parsedDate, beforeDate) ? beforeMessage || "".concat(rangeValidationString, " ").concat(before) : undefined;
};
var validateBetween = function validateBetween(value, values, customError, lang) {
  var validatedYear = value && value.length < 10;
  var startDate = legacyParse(values[0]);
  var endDate = legacyParse(values[1]);
  var parsedDate = legacyParse(value);
  var validationString = customError ? customError : lang === 'en' ? 'Invalid Date' : 'Fecha invalida';
  var rangedValidationString = customError ? customError : lang === 'en' ? "Date is not between ".concat(values[0], " and ").concat(values[1]) : "La fecha no est\xE1 entre ".concat(values[0], " y ").concat(values[1]);
  if (validatedYear) {
    return validationString;
  }
  return validate(value, customError, lang) || !isWithinInterval(parsedDate, {
    start: startDate,
    end: endDate
  }) ? rangedValidationString : undefined;
};
var validateBeforeToday = function validateBeforeToday(value, customError, beforeMessage, lang) {
  return validateBefore(value, format(Date.now(), 'MM/dd/yyyy'), customError, beforeMessage, lang);
};
var validateAfterToday = function validateAfterToday(value, customError, afterMessage, lang) {
  return validateAfter(value, format(Date.now(), 'MM/dd/yyyy'), customError, afterMessage, lang);
};
var DateInput = function DateInput(_ref) {
  var after = _ref.after,
    afterMessage = _ref.afterMessage,
    afterToday = _ref.afterToday,
    before = _ref.before,
    beforeMessage = _ref.beforeMessage,
    beforeToday = _ref.beforeToday,
    between = _ref.between,
    _ref$customErrorMessa = _ref.customErrorMessage,
    customErrorMessage = _ref$customErrorMessa === void 0 ? '' : _ref$customErrorMessa,
    field = _ref.field,
    label = _ref.label,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? 'en' : _ref$lang,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme,
    _ref$optional = _ref.optional,
    optional = _ref$optional === void 0 ? false : _ref$optional,
    rest = _objectWithoutProperties(_ref, _excluded);
  var validatorFunction = function validatorFunction(value) {
    if (optional && !value) {
      return undefined;
    }
    if (!!after) {
      return validateAfter(value, after, customErrorMessage, afterMessage, lang);
    }
    if (!!before) {
      return validateBefore(value, before, customErrorMessage, beforeMessage, lang);
    }
    if (!!between) {
      return validateBetween(value, between, customErrorMessage, lang);
    }
    if (!!afterToday) {
      return validateAfterToday(value, customErrorMessage, afterMessage, lang);
    }
    if (!!beforeToday) {
      return validateBeforeToday(value, customErrorMessage, beforeMessage, lang);
    }
    return validate(value, customErrorMessage, lang);
  };
  return /*#__PURE__*/React.createElement(_TextInput, _extends({}, rest, {
    field: field,
    label: label,
    placeholder: 'MM/DD/YYYY',
    maxLength: 10,
    theme: theme,
    validate: validatorFunction,
    validateOnBlur: true,
    optional: optional,
    language: lang
  }));
};
var _DateInput = withDefaultTheme(/*#__PURE__*/memo(DateInput));

export default _DateInput;
